var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechnologiesDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 146.135,
    height: 99.147,
    viewBox: "0 0 146.135 99.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1400",
    "data-name": "Ret\\xE2ngulo 1400",
    width: 146.135,
    height: 99.147,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2053",
    "data-name": "Grupo 2053",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1270",
    "data-name": "Caminho 1270",
    d: "M0,28.8v20.58H14.162V46.668h-11v-6.42H13.942V37.533H3.162V31.518h11V28.8Z",
    transform: "translate(0 33.313)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2054",
    "data-name": "Grupo 2054",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2053-2",
    "data-name": "Grupo 2053",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1271",
    "data-name": "Caminho 1271",
    d: "M9.967,44.272a8.988,8.988,0,0,0,6.638,2.9c3.414,0,4.617-1.7,4.617-3.179,0-2.159-2.4-2.776-5.09-3.455-3.384-.865-7.3-1.82-7.3-6.017,0-3.394,3.067-5.862,7.462-5.862a10.478,10.478,0,0,1,7.682,2.868l-1.833,2.284a8.34,8.34,0,0,0-6.1-2.407c-2.34,0-3.951,1.173-3.951,2.9,0,1.85,2.277,2.437,4.9,3.084,3.446.895,7.462,1.945,7.462,6.325,0,3.209-2.275,6.2-7.966,6.2a10.927,10.927,0,0,1-8.316-3.269Z",
    transform: "translate(9.442 33.147)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1272",
    "data-name": "Caminho 1272",
    d: "M18.98,44.272a8.988,8.988,0,0,0,6.638,2.9c3.416,0,4.617-1.7,4.617-3.179,0-2.159-2.4-2.776-5.09-3.455-3.384-.865-7.3-1.82-7.3-6.017,0-3.394,3.065-5.862,7.46-5.862a10.478,10.478,0,0,1,7.682,2.868l-1.833,2.284a8.335,8.335,0,0,0-6.1-2.407c-2.34,0-3.953,1.173-3.953,2.9,0,1.85,2.277,2.437,4.9,3.084,3.446.895,7.46,1.945,7.46,6.325,0,3.209-2.275,6.2-7.966,6.2a10.919,10.919,0,0,1-8.314-3.269Z",
    transform: "translate(19.869 33.147)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1273",
    "data-name": "Caminho 1273",
    d: "M26.794,49.382V28.8H40.958v2.715h-11v6.015H40.736v2.715H29.955v6.418h11v2.715Z",
    transform: "translate(30.989 33.313)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1274",
    "data-name": "Caminho 1274",
    d: "M50.386,49.382l-11.665-15.8v15.8H35.559V28.8h3.256L50.291,44.23V28.8h3.162V49.382Z",
    transform: "translate(41.127 33.313)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1275",
    "data-name": "Caminho 1275",
    d: "M52.29,49.382V31.519H45.745V28.8h16.22v2.715H55.452V49.382Z",
    transform: "translate(52.908 33.313)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1398",
    "data-name": "Ret\\xE2ngulo 1398",
    width: 3.162,
    height: 20.578,
    transform: "translate(118.949 62.116)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1276",
    "data-name": "Caminho 1276",
    d: "M75.391,49.383l-1.706-4.259H63.344l-1.706,4.259H58.16L66.538,28.8h3.953l8.376,20.58ZM68.5,31.488,64.263,42.379h8.5Z",
    transform: "translate(67.267 33.312)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1277",
    "data-name": "Caminho 1277",
    d: "M8.157,43.434H5.332v-1.08H12.2v1.08H9.393v6.58H8.157Z",
    transform: "translate(6.167 48.985)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1278",
    "data-name": "Caminho 1278",
    d: "M10.23,42.354H16.49v1.068H11.466v2.148h4.883v1.068H11.466v2.308H16.49v1.068H10.23Z",
    transform: "translate(11.832 48.985)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1279",
    "data-name": "Caminho 1279",
    d: "M14.778,46.257c0-2.366,1.893-3.962,4.507-3.962a4.23,4.23,0,0,1,3.636,1.7l-1.037.608a3.037,3.037,0,0,0-2.6-1.227,2.9,2.9,0,1,0,0,5.762,3.019,3.019,0,0,0,2.562-1.182l1.074.584a4.3,4.3,0,0,1-3.636,1.678c-2.614,0-4.507-1.6-4.507-3.962",
    transform: "translate(17.092 48.917)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1280",
    "data-name": "Caminho 1280",
    d: "M20.209,42.354h1.236v3.181H26.5V42.354H27.74v7.658H26.5v-3.4H21.445v3.4H20.209Z",
    transform: "translate(23.374 48.985)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1281",
    "data-name": "Caminho 1281",
    d: "M25.662,42.354h1.3l5.01,5.857V42.354H33.2v7.658H31.992L26.9,44.042v5.969H25.662Z",
    transform: "translate(29.681 48.985)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1282",
    "data-name": "Caminho 1282",
    d: "M30.947,46.259c0-2.32,1.788-3.964,4.423-3.964s4.423,1.643,4.423,3.964-1.788,3.96-4.423,3.96-4.423-1.641-4.423-3.96M35.37,49.14a2.893,2.893,0,1,0,0-5.765,2.893,2.893,0,1,0,0,5.765",
    transform: "translate(35.793 48.917)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1283",
    "data-name": "Caminho 1283",
    d: "M36.836,42.354h1.236v6.591h4.365v1.068h-5.6Z",
    transform: "translate(42.605 48.985)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1284",
    "data-name": "Caminho 1284",
    d: "M40.785,46.259c0-2.32,1.786-3.964,4.421-3.964s4.423,1.643,4.423,3.964-1.788,3.96-4.423,3.96-4.421-1.641-4.421-3.96m4.421,2.881a2.893,2.893,0,1,0,0-5.765,2.893,2.893,0,1,0,0,5.765",
    transform: "translate(47.172 48.917)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1285",
    "data-name": "Caminho 1285",
    d: "M46.5,46.257c0-2.435,1.954-3.962,4.544-3.962a4.324,4.324,0,0,1,3.61,1.63l-1.011.621a3.132,3.132,0,0,0-2.6-1.171c-1.885,0-3.261,1.137-3.261,2.881a2.955,2.955,0,0,0,3.261,2.894A4.32,4.32,0,0,0,53.5,48.4V47.093H50.428V46.026h4.309v2.86a5.318,5.318,0,0,1-3.694,1.344c-2.59,0-4.544-1.551-4.544-3.972",
    transform: "translate(53.78 48.917)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1399",
    "data-name": "Ret\\xE2ngulo 1399",
    width: 1.236,
    height: 7.658,
    transform: "translate(112.371 91.338)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1286",
    "data-name": "Caminho 1286",
    d: "M54.641,42.354H60.9v1.068H55.877v2.148H60.76v1.068H55.877v2.308H60.9v1.068H54.641Z",
    transform: "translate(63.198 48.985)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1287",
    "data-name": "Caminho 1287",
    d: "M59.129,48.875l.742-.908a4.268,4.268,0,0,0,2.989,1.171c1.482,0,2.1-.574,2.1-1.171,0-.815-.964-1.009-2.305-1.227-1.624-.254-3.272-.587-3.272-2.228,0-1.309,1.331-2.217,3.282-2.217A4.731,4.731,0,0,1,66.06,43.5l-.753.873a3.91,3.91,0,0,0-2.73-1c-1.177,0-1.893.412-1.893,1.044,0,.712.869.9,2.245,1.126,1.637.287,3.319.632,3.319,2.308,0,1.24-1.07,2.366-3.448,2.366a5.292,5.292,0,0,1-3.671-1.344",
    transform: "translate(68.388 48.917)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1288",
    "data-name": "Caminho 1288",
    d: "M43.036,27.594l6.355-6.2V14.076L43.005,7.85H35.557L29.2,14.05v7.317l6.384,6.226ZM30.251,14.475,35.99,8.868h6.584l5.765,5.627v6.468l-5.739,5.6H36.018l-5.767-5.62Z",
    transform: "translate(33.771 9.078)",
    fill: "#161615",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1289",
    "data-name": "Caminho 1289",
    d: "M60.685,53.6,76.074,38.586V15L60.7,0H36.538L21.146,15.018V38.6l15.374,15ZM22.2,15.443,36.971,1.027h23.3l14.758,14.4V38.161L60.249,52.578H36.956L22.2,38.176Z",
    transform: "translate(24.457 -0.001)",
    fill: "#161615",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1290",
    "data-name": "Caminho 1290",
    d: "M48.2,34.381h1.044V14.847L48.19,15.874ZM45.285,22.044H46.1V33.353H45.05V30.269H40.826V31.3h3.159v2.057H31.779l3.785-3.686V28.214l-6.327,6.168h17.91V20.124Zm-.246,4.113H43.985v1.027h1.055Zm0,2.055H43.985V29.24h1.055ZM39.771,29.24H42.93V26.165h-2.1v-1.63L46.1,19.38v.794l1.055-1.093.022-2.206-10.559,10.3v4.113h1.055V27.61l2.1-2.055Zm1.055-2.057H41.88v1.029H40.826Zm-1.055,3.086H38.719V31.3h1.052Z",
    transform: "translate(33.814 17.171)",
    fill: "#161615",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1291",
    "data-name": "Caminho 1291",
    d: "M35.513,30.564l.744.727L50.412,17.478H48.924Zm6.882-10.725.569.556-8.193,8-.746-.727,2.243-2.189-3-2.9-.744.727,2.243,2.189-1.5,1.447-8.622-8.413h5.344L31.044,17.5H22.1L34.771,29.859,45.1,19.777Zm-3.146,2.737-.746-.727-.746.727.746.727ZM37.755,24.03l-.744-.727-.744.727.744.729Zm-4.471-2.907,2.243,2.189,2.243-2.189-1.488-1.454,1.158-1.143h7.449l-.576.563,1.538-.045L47.466,17.5H32.534l-2.978,2.9.744.727,2.672-2.6h2.989Zm1.492,0,.735-.727.744.727-.744.727Zm-2.243.727-.744-.727-.746.727.746.727Z",
    transform: "translate(25.566 20.214)",
    fill: "#161615",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1292",
    "data-name": "Caminho 1292",
    d: "M22.14,26.412v1.027H42.148L41.09,26.41Zm12.642-2.847v.783h-11.6V23.322h3.159V19.207H25.29v3.086h-2.1V10.384l3.774,3.688h1.49L22.131,7.9V25.381H36.74ZM30.568,22.3H29.513v1.029h1.055Zm-2.107,0H27.408v1.029h1.052Zm-1.052-4.113v3.084h3.151V19.211H32.23L37.5,24.348h-.82L37.8,25.377l2.264.022L29.5,15.1H25.29v1.027h3.781l2.1,2.057Zm1.044,1.027h1.055V20.24H28.452Zm-2.107-2.055H25.29v1.029h1.055Z",
    transform: "translate(25.596 9.139)",
    fill: "#161615",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1293",
    "data-name": "Caminho 1293",
    d: "M22.9,14.024l-.755.725L36.306,28.561V27.105Zm10.99,6.711-.569.554-8.2-8,.746-.727,2.243,2.189,2.972-2.92-.746-.722L28.1,13.3l-1.482-1.466,8.633-8.417V8.63l1.055,1.027V.933L23.64,13.292,33.97,23.374Zm-2.8-3.069.746-.727-.746-.727-.746.727ZM29.6,16.212l.744-.727-.744-.727-.744.727Zm2.98-4.365-2.243,2.189,2.243,2.189,1.49-1.454,1.182,1.152v7.27l-.576-.561.045,1.5,1.585,1.574V11.112L33.326,8.2l-.746.727,2.672,2.607v2.909Zm0,1.454.746.722-.746.729-.744-.729Zm-.744-2.189.744-.729-.744-.727-.746.727Z",
    transform: "translate(25.616 1.078)",
    fill: "#161615",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1294",
    "data-name": "Caminho 1294",
    d: "M30.291.948h-1.05V20.482l1.052-1.029Zm2.916,12.338h-.8V1.966h1.05V5.052h4.214V4.023H34.507V1.966H46.716l-3.781,3.7V7.116L49.258.948H31.348V15.205Zm.246-4.113h1.055V8.145H33.453Zm0-2.057h1.055V6.089H33.453Zm5.269-1.027H35.558V9.173h2.1V10.8L32.4,15.943v-.8l-1.055,1.1-.024,2.208L41.883,8.145V4.032H40.831V7.718L38.721,9.775ZM37.667,8.145H36.614V7.116h1.052Zm1.055-3.084h1.055V4.032H38.721Z",
    transform: "translate(33.82 1.096)",
    fill: "#161615",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1295",
    "data-name": "Caminho 1295",
    d: "M47.428,1.7,46.682.97l-14.156,13.8h1.492ZM40.546,12.424l-.569-.556,8.2-8,.744.727L46.673,6.784l2.983,2.907.744-.727L48.157,6.776,49.645,5.32l8.633,8.426H52.949L51.9,14.772h8.939L48.172,2.415,37.842,12.5ZM43.7,9.685l.744.727.744-.727-.744-.727Zm1.488-1.454.744.727.746-.727L45.936,7.5Zm4.462,2.909L47.411,8.952,45.168,11.14l1.488,1.454-1.18,1.154H38.051l.576-.563-1.535.045-1.615,1.544h14.93l2.98-2.907-.744-.731-2.672,2.612H46.99Zm-1.49,0-.744.727-.738-.731.746-.729Zm2.243-.729.744.725.748-.729L51.15,9.68Z",
    transform: "translate(37.619 1.121)",
    fill: "#161615",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1296",
    "data-name": "Caminho 1296",
    d: "M56.356,8.919V7.89H36.345L37.4,8.919ZM43.714,11.763v-.785H55.3v1.029H52.151V16.12H53.2V13.036H55.31V24.946l-3.778-3.686H50.044l6.321,6.166V9.95H41.756Zm4.223,1.272h1.052V12.007H47.937Zm2.107,0H51.1V12.007H50.044ZM51.1,17.148V14.062H47.937V16.12H46.265L41,10.978h.815L40.691,9.95l-2.26-.024L48.987,20.232H53.2V19.2H49.427l-2.109-2.055ZM50.044,16.12H48.989V15.091h1.055Zm2.107,2.055H53.2V17.14H52.151Z",
    transform: "translate(42.036 9.125)",
    fill: "#161615",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1297",
    "data-name": "Caminho 1297",
    d: "M52.451,25.649l.744-.727L39.041,11.109v1.454Zm-10.99-6.713.567-.554,8.2,7.994-.744.727-2.243-2.189-2.98,2.909.744.727,2.243-2.189,1.49,1.456L40.1,36.238v-5.2l-1.055-1.029v8.723L51.713,26.376,41.383,16.293Zm2.8,3.077-.744.727.744.729.744-.729Zm1.49,1.456-.746.727.746.727L46.5,24.2Zm-2.976,4.356,2.243-2.189-2.243-2.189L41.286,24.9l-1.18-1.154V16.5l.574.561-.043-1.5-1.585-1.574V28.558l2.978,2.907.748-.727-2.672-2.607v-2.9Zm0-1.456-.748-.727.748-.727.744.727Zm.744,2.189-.744.727.744.727.744-.727Z",
    transform: "translate(45.154 12.848)",
    fill: "#161615",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologiesDark);
export default __webpack_public_path__ + "static/media/technologies-dark.fbc83ef0fa2375cb19f483be8cf7165f.svg";
export { ForwardRef as ReactComponent };